export default __webpack_public_path__ + "5ff81925ecb2697af2e9ad7a93e58899.png";